// import React, { useEffect, useState } from "react";
// import SideBar from "./SideBar";
// import TopBar from "./TopBar";
// import { useTranslation } from "react-i18next";
// import profileAvatar from "../Assets/imgs/profileAvatar.webp";
// import { IUserProfile } from "../types/post/Interface";
// import { getCookie } from "../utils/Common";
// import { Apinames } from "../utils/Apiname";
// import { UpdateUserProfileService } from "../services/UserProfile";
// const Profile = () => {
//   const [userData, setUserData] = useState<IUserProfile | null>(null);
//   const { t } = useTranslation();

//   useEffect(() => {
//     const cookie: any = getCookie("data");
//     if (cookie) {
//       try {
//         setUserData(cookie);
//         console.log("Profile==.", cookie);
//       } catch (error) {
//         console.error("Invalid cookie data:", error);
//       }
//     }
//   }, []);

//     const UpdateUserProfile = async (items:any) => {
//       try {

//           let data = {

//           };
//           let response = await UpdateUserProfileService(
//             Apinames.usersUpdate,
//             data
//           );
//           if (response.result && response.result.toLowerCase() === "success") {

//           }

//       } catch (error) {
//         console.log("onSubmitOtpPressed error::", error);

//       }
//     };

//   return (
//     <>
//       <div className="__dashboard">
//         <div className="__dashboard__wrapper">
//           <SideBar />
//           <div className="__dashboardRightSide">
//             <TopBar />
//             <div className="__dashboardContent">
//               <div className="__pageHeading">{t("profile.title")}</div>
//               <div className="__profileparent">
//                 <div className="__profileTop"></div>
//                 <div className="__profileDetail flex-cemter">
//                   <div className="__editProfile">
//                     <div>
//                       <div className="__profileAvatar">
//                         <img src={profileAvatar} alt="avatar" />
//                       </div>
//                       <div className="__profileuserName">{userData?.name}</div>
//                       <div
//                         className="__userjob"
//                         style={{ textAlign: "center" }}
//                       >
//                         {userData?.role}
//                       </div>
//                     </div>
//                     {/* <button className="__editBtn">{t("profile.edit")}</button> */}
//                   </div>

//                   <div className="__userDetailBox">
//                     <div className="flex">
//                       <div className="__leftSide">
//                         <div className="__detail">
//                           <p>{t("profile.email")}</p>
//                           <span>{userData?.email}</span>
//                         </div>
//                         {userData?.department && (
//                           <div className="__detail mb-0">
//                             <p>{t("Department")}</p>
//                             <span>{userData.department}</span>
//                           </div>
//                         )}
//                         <div className="__detail">
//                           <p>{t("profile.phoneNumber")}</p>
//                           <span>{userData?.number}</span>
//                         </div>
//                         <div className="__detail">
//                           <p>{t("profile.address")}</p>
//                           <span>{userData?.address}</span>
//                         </div>
//                       </div>

//                       <div className="__rightSide">
//                         <div className="__detail">
//                           <p>{t("profile.status")}</p>
//                           <span>{userData?.status}</span>
//                         </div>
//                         <div className="__detail">
//                           <p>{t("profile.vatNumber")}</p>
//                           <span>{userData?.vatNumber}</span>
//                         </div>
//                         <div className="__detail mb-0">
//                           <p>{t("profile.company")}</p>
//                           <span>{userData?.company}</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Profile;

import React, { useEffect, useState } from "react";
import SideBar from "./SideBar";
import TopBar from "./TopBar";
import { useTranslation } from "react-i18next";
import profileAvatar from "../Assets/imgs/profileAvatar.webp";
import { IUserProfile } from "../types/post/Interface";
import { getCookie, setCookie } from "../utils/Common";
import { Apinames } from "../utils/Apiname";
import { UpdateUserProfileService } from "../services/UserProfile";
import { Modal, Button, Form, Spinner } from "react-bootstrap";

const Profile = () => {
  const [userData, setUserData] = useState<IUserProfile | null>(null);
  const [editData, setEditData] = useState<IUserProfile | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");

  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [previewImage, setPreviewImage] = useState<string>(profileAvatar);
  const { t } = useTranslation();

  useEffect(() => {
    const cookie: any = getCookie("data");
    if (cookie) {
      setUserData(cookie);
      if (cookie.pic) setPreviewImage(cookie.pic);
    }
  }, []);

  const handleEdit = () => {
    setEditData({ ...userData } as IUserProfile);
    setPreviewImage(userData?.pic || profileAvatar);
    setShowModal(true);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (editData) {
      setEditData({ ...editData, [name]: value });
    }
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFileName(file.name);
      setSelectedImage(file);
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleUpdate = async () => {
    try {
      if (!editData) return;
      setIsLoading(true);

      const formData = new FormData();
      formData.append("name", editData.name || "");
      formData.append("number", editData.number || "");
      formData.append("vatNumber", editData.vatNumber || "");
      formData.append("company", editData.company || "");
      formData.append("address", editData.address || "");
      if (selectedImage) {
        formData.append("pic", selectedImage);
      }

      const response = await UpdateUserProfileService(
        Apinames.usersUpdate,
        formData
      );

      if (response.result) {
        alert("Profile updated successfully!");
        setUserData({ ...userData, ...editData });
        const prevCookie: any = getCookie("data");
        const updatedCookie = {
          ...prevCookie,
          name: editData.name,
          number: editData.number,
          vatNumber: editData.vatNumber,
          company: editData.company,
          address: editData.address,
          pic: selectedImage
            ? URL.createObjectURL(selectedImage)
            : prevCookie.pic,
        };
        setCookie(updatedCookie);
        setShowModal(false);
      }
    } catch (error) {
      console.error("Update error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="__dashboard">
        <div className="__dashboard__wrapper">
          <SideBar />
          <div className="__dashboardRightSide">
            <TopBar />
            <div className="__dashboardContent">
              <div className="__pageHeading">{t("profile.title")}</div>
              <div className="__profileparent">
                <div className="__profileTop"></div>
                <div className="__profileDetail flex-cemter">
                  <div className="__editProfile">
                    <div>
                      <div className="__profileAvatar">
                        <img
                          src={previewImage}
                          alt="avatar"
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "50%",
                          }}
                          className="avatar__icon"
                        />
                      </div>
                      <div className="__profileuserName">{userData?.name}</div>
                      <div
                        className="__userjob"
                        style={{ textAlign: "center" }}
                      >
                        {userData?.role}
                      </div>
                    </div>
                    <Button className="__editBtn mt-3" onClick={handleEdit}>
                      {t("profile.edit")}
                    </Button>
                  </div>

                  <div className="__userDetailBox">
                    <div className="flex">
                      <div className="__leftSide">
                        <div className="__detail">
                          <p>{t("profile.email")}</p>
                          <span>{userData?.email}</span>
                        </div>
                        <div className="__detail">
                          <p>{t("profile.phoneNumber")}</p>
                          <span>{userData?.number}</span>
                        </div>
                        <div className="__detail">
                          <p>{t("profile.address")}</p>
                          <span>{userData?.address}</span>
                        </div>
                      </div>

                      <div className="__rightSide">
                        <div className="__detail">
                          <p>{t("profile.status")}</p>
                          <span>{userData?.status}</span>
                        </div>
                        <div className="__detail">
                          <p>{t("profile.vatNumber")}</p>
                          <span>{userData?.vatNumber}</span>
                        </div>
                        <div className="__detail mb-0">
                          <p>{t("profile.company")}</p>
                          <span>{userData?.company}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Modal */}
                  <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                      <Modal.Title>{t("profile.edit_profile")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <Form.Group className="mb-3">
                          <Form.Label>{t("usermanagement.name")}</Form.Label>
                          <Form.Control
                            name="name"
                            value={editData?.name || ""}
                            onChange={handleInputChange}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>{t("profile.phoneNumber")}</Form.Label>
                          <Form.Control
                            name="number"
                            value={editData?.number || ""}
                            onChange={handleInputChange}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>{t("profile.address")}</Form.Label>
                          <Form.Control
                            name="address"
                            value={editData?.address || ""}
                            onChange={handleInputChange}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>{t("profile.vatNumber")}</Form.Label>
                          <Form.Control
                            name="vatNumber"
                            value={editData?.vatNumber || ""}
                            onChange={handleInputChange}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>{t("profile.company")}</Form.Label>
                          <Form.Control
                            name="company"
                            value={editData?.company || ""}
                            onChange={handleInputChange}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>
                            {t("profile.profile_picture")}
                          </Form.Label>
                          {/* <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                          /> */}
                          <div className="custom-file-upload">
                            <div className="choose__file">
                              <label
                                htmlFor="profileImage"
                                className="upload-label"
                              >
                                {t("placeholders.choose_file")}
                              </label>
                              <input
                                id="profileImage"
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange}
                                style={{ display: "none" }}
                              />
                            </div>
                            <div>
                              <span className="file-name">
                                {selectedFileName ||
                                  t("placeholders.no_file_chosen")}
                              </span>
                            </div>
                          </div>
                          {previewImage && (
                            <img
                              src={previewImage}
                              alt="preview"
                              style={{
                                marginTop: "10px",
                                width: "100px",
                                height: "100px",
                                borderRadius: "50%",
                              }}
                              className="avatar___icon"
                            />
                          )}
                        </Form.Group>
                      </Form>
                    </Modal.Body>
                    <Modal.Footer>
                      {isLoading ? (
                        <Button variant="primary">
                          <Spinner animation="border" role="status" size="sm">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </Button>
                      ) : (
                        <>
                          <Button
                            variant="secondary"
                            onClick={() => setShowModal(false)}
                          >
                            {t("common.cancel")}
                          </Button>
                          <Button variant="primary" onClick={handleUpdate}>
                            {t("common.update")}
                          </Button>
                        </>
                      )}
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
